// ButtonTotal helper functions
import { Vendor } from "@multicines/types";
import { SNACKS_VENDOR, TICKETS_VENDOR } from "@multicines/utils";

import { ButtonTotalProps } from "./ButtonTotal.types";

export const getSelectedVendor = (
  filter: ButtonTotalProps["vendor"],
  selectedTicketVendorId?: Vendor["id"],
  selectedSnackVendorId?: Vendor["id"]
): Vendor["id"] | undefined => {
  if (filter === "tickets") {
    return selectedTicketVendorId ?? TICKETS_VENDOR.id;
  }
  if (filter === "snacks") {
    return selectedSnackVendorId ?? SNACKS_VENDOR.id;
  }
  if (filter === "all") {
    return undefined;
  }
  throw new Error(`Unsupported vendor ${filter}`);
};
